import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'

interface CustomizeChartButtonProps {
  onPress: () => void
  text?: string
}

export const CustomizeChartButton = ({ onPress, text }: CustomizeChartButtonProps) => {
  const styles = useStyleSheet(themedStyle)

  return (
    <View>
      <TouchableOpacity
        accessibilityLabel={text || 'Customize Home Screen'}
        onPress={onPress}
        style={styles.customizeActionText}
      >
        <Text type="regular" bold style={styles.customizeActionText}>
          {text || 'Customize'}
        </Text>
      </TouchableOpacity>
    </View>
  )
}

const themedStyle = StyleService.create({
  customizeActionText: {
    color: 'theme.text.link',
  },
})
